module.exports = __webpack_public_path__ + "static/media/same_direction.1d7fc18f.svg";